import { useSelector } from "react-redux";
import {
  selectAuthUser,
  selectIsAuthenticated,
  selectAuthChecked,
} from "../features/authSlice";

export const useAuth = () => {
  const user = useSelector(selectAuthUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const authChecked = useSelector(selectAuthChecked);
  const role = user?.role || null;
  const assignedRestaurants =
    user?.restaurants?.map((restaurant) => ({
      id: restaurant.restaurantId,
      role: restaurant.role,
    })) || [];

  return { isAuthenticated, authChecked, user, role, assignedRestaurants };
};
